import { t } from "@/i18n-js/instance";

import { DefaultFullPreview } from "../../..";
import type { ComponentLineProps } from "../types";
import { shouldExpandFirstPayment } from "../variants/helpers";

export const TotalDueTodayLine = ({ preview, options }: ComponentLineProps) => {
  if (!shouldExpandFirstPayment(preview)) {
    return null;
  }
  return (
    <DefaultFullPreview.PreviewEntry
      label={t("paywall_checkout.amount_due")}
      value={preview.formatted_amount_due_now}
      dataTestId="checkout-form-preview-total-due-today-line"
      {...options}
    />
  );
};
